// extracted by mini-css-extract-plugin
module.exports = {"textArea":"styles_textArea__2Psb1","container":"styles_container__2q_8R","modal":"styles_modal__HF_vl","p":"styles_p__2sNTQ"};